export default __webpack_public_path__ + "bf6c1346197c709111ee64145c04de55.png";